import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { user } from '../model/user.fragments';
import { UserOutput } from '../model/user.output';

export interface FetchUserByIdParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class FetchUserByIdApiQuery extends ApiQuery<
	UserOutput,
	FetchUserByIdParams
> {
	client = 'iam';
	document = gql`
		query FetchUserById($id: UUID!) {
			fetchUserById(id: $id) {
				...User
			}
		}
		${user}
	`;
	method = 'fetchUserById';
}
